import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import '@/plugins/vue-frag';
import '@/plugins/vue-dragscroll';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import App from './App.vue';
import router from '@/router';
import store from './store';

Vue.config.productionTip = false;

Vue.component('default-layout', DefaultLayout);

store.dispatch('Auth/autoLogin').then(() => {
  new Vue({
    router,
    vuetify,
    store,
    render: (h) => h(App),
  }).$mount('#app');
});
